import { useTranslation } from 'react-i18next';
import ButtonAction from "./ButtonAction";
import { EditIcon } from './IconButtons';

const ImportDataBtn = (props) => {
    const { id, classes } = props;
    const { t } = useTranslation();

    const handleClick = (e) => {
        props?.onClickFn(e);
    };

    return (
        <ButtonAction
            id={id}
            name={t('import_data')}
            splitName={false}
            Icon={EditIcon}
            className={"btn-icon-accent-450 " + classes}
            onClick={handleClick}
        />
    );
};

export default ImportDataBtn;
